class CModal {
	static select = $context => $context.select('.modal__inner');

	_filter = '';

	constructor($modal) {
		this.$modal = $modal;

		this.bindEvents();
	}

	bindEvents() {
		const self = this;

		self.$modal.find('.modal__close').on('click', function () {
			ModalUtil.close();
		});
	}
}

export default () => Component(CModal.select, $modal => new CModal($modal));
/* TODO перенесети мадалки авторизации в cmodal*/
